import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
export const state = {
  courseList: [],
  courseSessionList: [],
  batch_id: '',
  calendarEventList: [],
  trainingEventList: [],
}

export const getters = {}

export const mutations = {
  CACHE_COURSE_LIST(state, newList) {
    state.courseList = newList
  },
  CACHE_COURSE_SESSION_LIST(state, newList) {
    state.courseSessionList = newList
  },
  CACHE_CALENDAR_EVENT_LIST(state, newList) {
    state.calendarEventList = newList
  },
  CACHE_TRAINING_EVENT_LIST(state, newList) {
    state.trainingEventList = newList
  },
}

export const actions = {
  fetchCourseList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/course/list?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_COURSE_LIST', list)
        return list
      })
  },
  fetchCourseById({ commit, state, rootState }, { courseId }) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/course/${courseId}`)
      .then((response) => {
        const list = response.data
        return list
      })
  },

  fetchCourseBatchList({ commit, dispatch, rootState }, { filter }) {
    commit('CACHE_COURSE_SESSION_LIST', [])
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/coursebatch?${arrayToQueryString(
          filter
        )}`
      )
      .then((response) => {
        const batchlist = response.data.docs
        if (batchlist.length >= 1) {
          dispatch('fetchCourseSessionList', batchlist[0]._id)
          this.state.batch_id = batchlist[0]._id
        }
        return batchlist
      })
  },

  fetchCourseSessionList({ commit, state, rootState }, { filter }) {
    var contentFilter = {
      filter: this.state.batch_id,
      fields: 'batch_id',
      page: 1,
      limit: 100,
      sort: 'name',
      order: '1',
    }
    return axios
      .get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/course-content?${arrayToQueryString(contentFilter)}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_COURSE_SESSION_LIST', list)
        return list
      })
  },

  fetchCalendarEventList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/calendar-event?${arrayToQueryString(filter)}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_CALENDAR_EVENT_LIST', list)
        return list
      })
  },

  addCalendarEvent({ commit, state, rootState }, { eventData }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/calendar-event`, eventData)
      .then((response) => {
        const event = response.data
        return event
      })
  },

  updateCalendarEvent({ commit, state, rootState }, { eventData }) {
    return axios
      .patch(
        `${process.env.VUE_APP_API_BASE_URL}/calendar-event/${eventData.id}`,
        eventData
      )
      .then((response) => {
        const event = response.data
        return event
      })
  },

  deleteCalendarEvent({ commit, state, rootState }, { calendarEventData }) {
    return axios
      .delete(
        `${process.env.VUE_APP_API_BASE_URL}/calendar-event/${
          calendarEventData.id
        }`
      )
      .then((response) => {
        const event = response.data
        return event
      })
  },

  fetchTrainingEventList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/training-calendar-event?${arrayToQueryString(filter)}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_TRAINING_EVENT_LIST', list)
        return list
      })
  },

  addTrainingEvent({ commit, state, rootState }, { eventData }) {
    return axios
      .post(
        `${process.env.VUE_APP_API_BASE_URL}/training-calendar-event`,
        eventData
      )
      .then((response) => {
        const event = response.data
        return event
      })
  },

  updateTrainingEvent({ commit, state, rootState }, { eventData }) {
    return axios
      .patch(
        `${process.env.VUE_APP_API_BASE_URL}/training-calendar-event/${
          eventData.id
        }`,
        eventData
      )
      .then((response) => {
        const event = response.data
        return event
      })
  },

  deleteTrainingEvent({ commit, state, rootState }, { trainingEventData }) {
    return axios
      .delete(
        `${process.env.VUE_APP_API_BASE_URL}/training-calendar-event/${
          trainingEventData.id
        }`
      )
      .then((response) => {
        const event = response.data
        return event
      })
  },
  addCourse({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/course`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  getCourse({ commit, state, rootState }, { Data }) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/course/${Data.id}`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  updateCourse({ commit, state, rootState }, { Data }) {
    return axios
      .patch(`${process.env.VUE_APP_API_BASE_URL}/course/${Data.id}`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  deleteCourse({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/course/${Data.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  addCoursebatch({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/coursebatch`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  deleteCourseContent({ commit, state, rootState }, { Data }) {
    return axios
      .delete(`${process.env.VUE_APP_API_BASE_URL}/course-content/${Data.id}`)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  addCourseContent({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/course-content`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  fileUpload({ commit, state, rootState }, { Data }) {
    return axios
      .post(`${process.env.VUE_APP_API_BASE_URL}/course-content/file`, Data)
      .then((response) => {
        const data = response.data
        return data
      })
  },
  getVideos({ commit, state, rootState }, { Data }) {
    return axios
      .get(
        `${process.env.VUE_APP_API_BASE_URL}/course-content/videos/${Data.id}`
      )
      .then((response) => {
        const data = response.data
        return data
      })
  },
  updateCourseSession({ commit, state, rootState }, { courseData }) {
    return axios
      .patch(
        `${process.env.VUE_APP_API_BASE_URL}/course-content/${courseData.id}`,
        courseData
      )
      .then((response) => {
        const data = response.data
        return data
      })
  },
}
